import type { LabelInValue } from 'models';
import { Modal, type ModalOptions, message } from 'ui';
import { useInviteUsersMutation } from '../../../queries';
import { SmsInviteForm, type SmsInviteFormValues } from './sms-invite-form';

type P = {
  onCancel: () => void;
  options: ModalOptions<SmsInviteModalOptions>;
};

type SmsInviteModalOptions = {
  community: LabelInValue;
};

const SmsInviteModal = ({ onCancel, options }: P) => {
  const { isPending: isInvitingUsers, mutate: inviteUsers } = useInviteUsersMutation();

  const onSubmit = (data: SmsInviteFormValues) => {
    inviteUsers(
      {
        id: data.communityId,
        invitees: {
          emails: [],
          phones: data.phones,
          userIds: [],
        },
      },
      {
        onSuccess() {
          message.success('Invitations sent successfully');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={options.isOpened} onCancel={onCancel} title="Invite via SMS">
      {options.isOpened ? (
        <Modal.HugContent>
          <SmsInviteForm
            community={options.community}
            isSubmitting={isInvitingUsers}
            onCancel={onCancel}
            onSubmit={onSubmit}
          />
        </Modal.HugContent>
      ) : null}
    </Modal>
  );
};

export default SmsInviteModal;
